import { PriceSettingsTab } from '../../containers/PriceSettingsContent/PriceSettingsNavigator'

export function getPriceSettingsTabFromPendingAction(
  action?: string,
): PriceSettingsTab | null {
  if (!action || !action.includes('/tab/')) return null
  const tab = Number(action.split('/')[3])
  return Number.isNaN(tab) ? null : tab
}

export function shouldLeavePriceSettingsToGrid(action?: string): boolean {
  return Boolean(action && action.includes('/set'))
}
